import { h, Host } from "@stencil/core";
export class FilterableList {
    constructor() {
        this.filterable = false;
        this.filter = undefined;
        this.searchPlaceholder = "Search";
        this.noContentMessage = "No items found";
        this.numOfItems = undefined;
    }
    domNode;
    /**
     * Emitted when the filter value changes
     */
    uxFilterChange;
    filterValue = "";
    /** returns true when item should be shown according to the filter */
    isInFilter(itemName) {
        return this.filterValue.length === 0 || itemName.toLowerCase().includes(this.filterValue);
    }
    /**
     * Handles the filter change event.
     * @param event - The keyboard event.
     */
    onFilterChange(event) {
        const inputElement = event.target;
        this.filterValue = inputElement.value.toLowerCase();
        // @ts-expect-error Check for typing
        const slottedElements = this.domNode.shadowRoot.querySelector("slot").assignedElements();
        for (const element of slottedElements) {
            const label = element.getAttribute("label") || element.getAttribute("value") || element.getAttribute("name");
            const slottedElement = element;
            // @ts-expect-error Check for typing
            slottedElement.hidden = !this.isInFilter(label);
        }
        // @ts-expect-error Check for typing
        this.numOfItems = slottedElements.filter((element) => !element.hidden).length;
    }
    render() {
        const filterInput = this.filterable && (h("div", { key: '12b19639561a858d2051d8be10e167c33e78e5ef', class: "ux-list__filter" }, h("ux-input", { key: '3a4293a53ad76c448dc98296a1aeb550dd25a79a', id: "searchInput", type: "text", placeholder: this.searchPlaceholder, onUxInput: (e) => this.onFilterChange(e) })));
        return (h(Host, { key: '17106da77f009483783e1735205d87608d8d1696', role: "list" }, filterInput, h("slot", { key: '55fdc51479430263f02f808f3582cf79f0297354' }), this.numOfItems === 0 && h("div", { key: '4456eb510b0832feedec7275a70932ddba9f1fe9', id: "noContent" }, this.noContentMessage)));
    }
    static get is() { return "ux-filterable-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["filterable-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["filterable-list.css"]
        };
    }
    static get properties() {
        return {
            "filterable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The filterable list items"
                },
                "attribute": "filterable",
                "reflect": false,
                "defaultValue": "false"
            },
            "filter": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [{
                            "name": "default",
                            "text": "empty"
                        }],
                    "text": "The filter string to be applied to the list"
                },
                "attribute": "filter",
                "reflect": false
            },
            "searchPlaceholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The placeholder text to be displayed in the search input"
                },
                "attribute": "search-placeholder",
                "reflect": false,
                "defaultValue": "\"Search\""
            },
            "noContentMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The message to be displayed when no items are found"
                },
                "attribute": "no-content-message",
                "reflect": false,
                "defaultValue": "\"No items found\""
            }
        };
    }
    static get states() {
        return {
            "numOfItems": {}
        };
    }
    static get events() {
        return [{
                "method": "uxFilterChange",
                "name": "uxFilterChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the filter value changes"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "domNode"; }
}
//# sourceMappingURL=filterable-list.js.map
